import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { FEATURE_MATRIX } from '@/config/features'
import { NotAllowedClarityPage } from '@/screens/error'
import KPIGoalPlanPage from '@/screens/targets/KpiGoalPlanPage'
import KPIPayoutPage from '@/screens/targets/KpiPayoutPage'
import { selectTenant, useAppSelector } from '@/store'

export default function TargetsPage() {
  const { t } = useTranslation()
  const { id } = useParams()
  const tenant = useAppSelector(selectTenant)
  const features = FEATURE_MATRIX[tenant]

  if (id === 'kpi-payout') {
    return features.targetsKpiPayout ? (
      <KPIPayoutPage />
    ) : (
        <NotAllowedClarityPage pageTitle={t('targets.navigation.kpiPayout')} />
    )
  }
  if (id === 'goal-plans') {
    return features.targetsGoalPlans ? (
      <KPIGoalPlanPage />
    ) : (
        <NotAllowedClarityPage pageTitle={t('targets.navigation.kpiGoalPlan')} />
    )
  }
}
